jQuery(document).ready(function($) {

  // If there is no tenants directory on page, JS is not needed so it returns the function
  if (!$("#tenants-directory__tenants").length) return;

  // Enable mixitup filter
  const mixer = mixitup('#tenants-directory__tenants', {
    multifilter: {
      enable: true
    }
  });

  // Tenants category dropdown
  var dropdown = false;
  $("#tenants-directory__category-btn").click(function() {
    if ($(this).hasClass("expanded")) {
      $(this).removeClass("expanded");
      $("#tenants-directory__taxonomies-fieldset").slideUp(200);
      dropdown = false;
    } else {
      $(this).addClass("expanded");
      $("#tenants-directory__taxonomies-fieldset").slideDown(200);
      dropdown = true;
    }
  });
  // If user clicks anywhere else while dropdown is expanded, hide dropdown
  $("body").click(function(e) {
    // If dropdown not expanded, return
    if (!dropdown) return;

    if (!$("#tenants-directory__category-wrapper").get(0).contains(e.target)) {
      $("#tenants-directory__category-btn").removeClass("expanded");
      $("#tenants-directory__taxonomies-fieldset").slideUp(200);
      dropdown = false;
    }
  });

  // Tenants taxonomy sub-dropdown
  $(".tenants-directory__taxonomy-btn").click(function() {
    let id = $(this).attr("id").split("tenants-directory__taxonomy-btn--")[1];
    if ($(this).hasClass("expanded")) {
      $(this).removeClass("expanded");
      $("#tenants-directory__taxonomy-dropdown--" + id).slideUp(200);
    } else {
      $(".tenants-directory__taxonomy-btn.expanded").removeClass("expanded");
      $(".tenants-directory__taxonomy-dropdown").slideUp(200);
      $(this).addClass("expanded");
      $("#tenants-directory__taxonomy-dropdown--" + id).slideDown(200);
    }
  });

  // On input selection
  $(".tenants-directory__taxonomies-fieldset input").change(function() {
    let val = $(".tenants-directory__taxonomies-fieldset input:checked").siblings("label").html();
    $("#tenants-directory__category-text").html(val);
    $(".tenants-directory__category-btn.expanded").removeClass("expanded");
    $("#tenants-directory__taxonomies-fieldset").slideUp(200); 
  });

  // Clear category filter
  $("#tenants-directory__clear").click(function() {
    $(".tenants-directory__taxonomy-btn.expanded").removeClass("expanded");
    $(".tenants-directory__taxonomy-dropdown").slideUp(200);
    $("#tenants-directory__category-text").html("Filter by Category");
  });

  // URL Filter
  if (window.location.search && window.location.search.indexOf("category=") > -1) {
    let cat = window.location.search.split("category=")[1];
    $(".tenants-directory__taxonomies-fieldset #category--" + cat).click();
  }

});